import { styled } from "styled-components";

//닉네임
export const Nickname = styled.span`
  font-size: 18px;
  margin-right: 10px;
`;
